import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose</span> TekRevol Mobile App Support and
              Maintenance Services?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              Choosing TekRevol for app maintenance and support ensures
              specialized proficiency and unwavering dedication to excellence.
            </p>
            <p>
              Our dedicated team understands app complexities, providing
              top-tier solutions aligned with your objectives. What sets us
              apart is adaptability, crafting customized solutions to suit your
              unique needs, ensuring an impactful digital presence.
            </p>
            <p>
              Beyond development, we offer continuous support, ensuring your app
              consistently delivers optimal performance.
            </p>
            <p>
              Collaborate with TekRevol for a seamless and engaging user
              experience, meeting the ever-evolving demands of the digital
              landscape.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult with Us Today
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="text-center">
            <StaticImage
              src="../../images/services-usa/mobile-support/why_choose_support.webp"
              alt="tekrevol_android"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={590}
              height={649}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
